import { render, staticRenderFns } from "./route-with-children.vue?vue&type=template&id=35642d70&"
import script from "./route-with-children.vue?vue&type=script&lang=js&"
export * from "./route-with-children.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports